import { Paper, Text } from '@mantine/core';
import cn from 'classnames';
import * as React from 'react';

import MarkdownRenderer from '@/components/ui/MarkdownRenderer';

import AiAnswer from '../AiAnswer';

import s from './MessageBubble.module.scss';

type Props = {
  role: 'user' | 'assistant';
  text: string;
  index?: number;
  status?: 'done' | 'loading' | 'error' | 'cancelled';
  isLoadingAnswer?: boolean;
  answerId?: string;
  isMarkdown?: boolean;
  activitySummary?: string | null;
  activityMessageId?: string;
  onActivityOpen?: (messageId: string) => void;
};

const MessageBubble: React.FC<Props> = ({
  role,
  text,
  index = 0,
  isLoadingAnswer,
  status,
  answerId,
  isMarkdown,
  activitySummary,
  activityMessageId,
  onActivityOpen,
}) => {
  const isUser = role === 'user';
  const handleActivityOpen = React.useCallback(() => {
    if (!activityMessageId || !onActivityOpen) {
      return;
    }

    onActivityOpen(activityMessageId);
  }, [activityMessageId, onActivityOpen]);

  return (
    <div className={cn(s.root, isUser ? s.root_user : s.root_assistant)} style={{ ['--i' as any]: index }}>
      <Paper radius="lg" className={cn(s.bubble, isUser ? s.root__user : s.root__assistant)}>
        {isUser ? (
          isMarkdown ? (
            <MarkdownRenderer content={text} />
          ) : (
            <Text>{text}</Text>
          )
        ) : (
          <AiAnswer
            answerId={answerId}
            status={status}
            isLoadingAnswer={isLoadingAnswer && status === 'loading'}
            text={text}
            activitySummary={activitySummary ?? undefined}
            onActivityOpen={activityMessageId ? handleActivityOpen : undefined}
          />
        )}
      </Paper>
    </div>
  );
};

export default React.memo(MessageBubble);
